import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { EntityProfileType } from "@common/types/entity";
import { entityTypeV2Labels } from "@common/constants/entity";
import { ClientsCloseOverviewRow } from "../clientsCloseOverviewViewConfig";

export const CloseLegalTypeCell = memo(
    ({
        getValue,
        row,
    }: CellContext<
        ViewTableFeatures,
        ClientsCloseOverviewRow,
        EntityProfileType | null
    >) => {
        if (row.original.rowType !== "entity") {
            return null;
        }

        const legalType = getValue();

        if (!legalType) {
            return null;
        }

        return <span>{entityTypeV2Labels[legalType]}</span>;
    },
);

CloseLegalTypeCell.displayName = "CloseLegalTypeCell";
